import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <rect width="12" height="12" x="2" y="2" rx="2" fillRule="evenodd"/>
  </svg>
);
